class CustomEventTarget extends EventTarget {}
export const eventTarget = new CustomEventTarget();
